export type DiscoveryMapSnapState = 'peek' | 'preview' | 'expanded'

interface SearchAreaAffordanceState {
  showSearchArea: boolean
  isOnlyShowSelected: boolean
  isMobileFilterOpen: boolean
  hasSelectedShop: boolean
  isDesktopLayout: boolean
  mobileResultsSnapState: DiscoveryMapSnapState
}

export function shouldRenderSearchAreaButton({
  showSearchArea,
  isOnlyShowSelected,
  isMobileFilterOpen,
  hasSelectedShop,
  isDesktopLayout,
  mobileResultsSnapState,
}: SearchAreaAffordanceState): boolean {
  if (!showSearchArea) return false
  if (isOnlyShowSelected || isMobileFilterOpen || hasSelectedShop) return false
  if (!isDesktopLayout && mobileResultsSnapState === 'expanded') return false
  return true
}
